enum ToiletState {
  Up,
  Down,
}

export default ToiletState;
